const WorkingEnvironment = {};
const getWorkingEnvironment = (state = WorkingEnvironment, action) => {
    if(action.type === "GET_WORKING_ENVIRONMENT"){
        state   = action.envData
    }
    return state;
}

export default getWorkingEnvironment;